// Zoom overlay — instantané + préchargement au survol
let overlay;

function getZoomImageUrl(image, zoomWidth = 3000) {
  const baseUrl = image.currentSrc || image.src;
  const url = new URL(baseUrl, window.location.origin);

  if (url.searchParams.has('width')) {
    url.searchParams.set('width', String(zoomWidth));
  } else {
    url.searchParams.append('width', String(zoomWidth));
  }

  return url.toString();
}

function createOverlay(image, zoomWidth) {
  overlay = document.createElement('div');
  overlay.setAttribute('class', 'image-magnify-full-size');
  overlay.setAttribute('aria-hidden', 'true');

  const zoomImageUrl = getZoomImageUrl(image, zoomWidth);

  overlay.style.backgroundImage = `url('${zoomImageUrl}')`;
  overlay.style.backgroundColor = 'var(--gradient-background)';
  image.parentElement.insertBefore(overlay, image);

  return overlay;
}

function moveWithHover(image, event, zoomRatio) {
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.clientWidth * zoomRatio}px auto`;
}

function magnify(image, zoomRatio, zoomWidth) {
  const newOverlay = createOverlay(image, zoomWidth);
  newOverlay.onclick = () => newOverlay.remove();
  newOverlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  newOverlay.onmouseleave = () => newOverlay.remove();
}

function enableZoomOnHover(zoomRatio = 2, zoomWidth = 3000) {
  const images = document.querySelectorAll('.image-magnify-hover');

  images.forEach((image) => {
    const zoomSrc = getZoomImageUrl(image, zoomWidth);

// 🔥 preload AVANT interaction (au scroll)
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      const preload = new Image();
      preload.src = zoomSrc;
      observer.disconnect();
    }
  });
});

observer.observe(image);

    image.onclick = (event) => {
      magnify(image, zoomRatio, zoomWidth);
      moveWithHover(image, event, zoomRatio);
    };
  });
}

enableZoomOnHover(2, 3000);